/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { DtoRegistryOfficeTypeCreate } from '../../models/dto-registry-office-type-create';
import { RegistryOfficeType } from '../../models/registry-office-type';

export interface OfficeControllerRenameType$Params {
  idType: number;
      body: DtoRegistryOfficeTypeCreate
}

export function officeControllerRenameType(http: HttpClient, rootUrl: string, params: OfficeControllerRenameType$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: RegistryOfficeType;
}>> {
  const rb = new RequestBuilder(rootUrl, officeControllerRenameType.PATH, 'patch');
  if (params) {
    rb.path('idType', params.idType, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: RegistryOfficeType;
      }>;
    })
  );
}

officeControllerRenameType.PATH = '/registry/office/types/{idType}';
